import { CHECK_STATUS } from '../types';
import { getDisplayStatus } from '@upshow/brightsign/src';

export const id = 'brightsignDisplay';
export const label = 'Display & HDCP';

export async function run (_ctx) {
  const start = Date.now();
  const status = await getDisplayStatus();
  const durationMs = Date.now() - start;

  if (!status.available) {
    return {
      id,
      label,
      status: CHECK_STATUS.SKIPPED,
      detail: 'Not checked — unsupported on this firmware',
      detailData: { notChecked: true, reason: status.reason },
      durationMs,
    };
  }

  if (!status.attached || !status.hdcpAuthenticated) {
    return {
      id,
      label,
      status: CHECK_STATUS.FAIL,
      detail: !status.attached ? 'No display detected' : 'HDCP authentication failed',
      detailData: { attached: status.attached, hdcpAuthenticated: status.hdcpAuthenticated },
      durationMs,
    };
  }

  if (status.outputPowered === false) {
    return {
      id,
      label,
      status: CHECK_STATUS.AT_RISK,
      detail: 'Display detected but appears powered off',
      detailData: { outputPowered: status.outputPowered, manufacturer: status.edidManufacturer, monitorName: status.edidMonitorName },
      durationMs,
    };
  }

  if (status.edidReadable === false) {
    return {
      id,
      label,
      status: CHECK_STATUS.AT_RISK,
      detail: 'Display detected but EDID unreadable',
      detailData: { edidReadable: status.edidReadable, manufacturer: status.edidManufacturer, monitorName: status.edidMonitorName },
      durationMs,
    };
  }

  return {
    id,
    label,
    status: CHECK_STATUS.PASS,
    detail: 'Display connected — HDCP OK',
    detailData: { outputPowered: status.outputPowered, manufacturer: status.edidManufacturer, monitorName: status.edidMonitorName },
    durationMs,
  };
}
